import GridCenter from "../../components/Generics/GridCenter";
import DashboardPageLayout from "../../components/layout/DashboardPageLayout";
import { CfgEmpresaProvider } from "../../contexts/CfgEmpresaContext/CfgEmpresaContext";
import EmpresaPage from "../../pages/Empresa/EmpresaPage";
import HomePage from "../../pages/home/HomePage";
import PerfisPage from "../../pages/Perfis/PerfisPage";
import UsuariosPage from "../../pages/Usuarios/UsuariosPage";
import { RouteType } from "../config";
import SettingsIcon from "@mui/icons-material/Settings";

const grupoConfiguracao: RouteType = {
  path: "/configuracoes",
  element: <DashboardPageLayout />,
  state: "configuracoes",
  show: true,
  sidebarProps: {
    displayText: "Configurações",
    icon: <SettingsIcon />,
  },

  child: [
    {
      index: true,
      element: <HomePage />,
      state: "configuracao.index",
      show: true,
    },
    {
      path: "/configuracoes/empresa",
      element: (
        <GridCenter>
          <CfgEmpresaProvider>
            <EmpresaPage />
          </CfgEmpresaProvider>
        </GridCenter>
      ),
      state: "configuracao.empresa",
      show: true,
      sidebarProps: {
        displayText: "Empresa",
      },
    },
    {
      path: "/configuracoes/usuarios",
      element: <UsuariosPage />,
      state: "configuracao.usuario",
      show: true,
      sidebarProps: {
        displayText: "Usuários",
      },
    },
    {
      path: "/configuracoes/perfis",
      element: <PerfisPage />,
      state: "configuracao.perfil",
      show: true,
      sidebarProps: {
        displayText: "Perfis",
      },
    },
  ],
};

export default grupoConfiguracao;
